var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServerside(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "51px",
    viewBox: "0 0 73 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C7C7C7",
    x: 0,
    y: 0,
    width: 73,
    height: 51
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(18.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#615C5C",
    strokeWidth: 0.5,
    fill: "#282727",
    x: 0.968204489,
    y: 1.1408686,
    width: 33.6147132,
    height: 38.6091314
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#050505",
    strokeWidth: 0.9,
    fill: "#616161",
    x: 0.45,
    y: 0.45,
    width: 35.1,
    height: 11.0376392
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E15252",
    x: 2.51371571,
    y: 5.34521158,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69A4FF",
    x: 7.09226933,
    y: 5.34521158,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#78A045",
    x: 11.6708229,
    y: 5.34521158,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#B6FF00",
    cx: 33.0822943,
    cy: 6.28062361,
    rx: 1.12219451,
    ry: 1.11358575
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 17.9551122,
    y: 3.56347439,
    width: 12.2992519,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#FFFFFF",
    x: 18.0448878,
    y: 5.34521158,
    width: 12.2992519,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#FFFFFF",
    x: 18.0448878,
    y: 7.12694878,
    width: 12.2992519,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#FFFFFF",
    x: 18.0448878,
    y: 8.90868597,
    width: 12.2992519,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#050505",
    strokeWidth: 0.9,
    fill: "#616161",
    x: 0.45,
    y: 13.9021158,
    width: 35.1,
    height: 11.0376392
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1EAD63",
    x: 2.51371571,
    y: 18.7973274,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1B273A",
    x: 7.09226933,
    y: 18.7973274,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#78A045",
    x: 11.6708229,
    y: 18.7973274,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#CAD5AE",
    cx: 33.0822943,
    cy: 19.7327394,
    rx: 1.12219451,
    ry: 1.11358575
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 17.9551122,
    y: 17.0155902,
    width: 12.2992519,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#FFFFFF",
    x: 18.0448878,
    y: 18.7973274,
    width: 12.2992519,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#FFFFFF",
    x: 18.0448878,
    y: 20.5790646,
    width: 12.2992519,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#FFFFFF",
    x: 18.0448878,
    y: 22.3608018,
    width: 12.2992519,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#050505",
    strokeWidth: 0.9,
    fill: "#616161",
    x: 0.45,
    y: 27.1760579,
    width: 35.1,
    height: 11.0376392
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E152C5",
    x: 2.51371571,
    y: 32.0712695,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69FFB6",
    x: 7.09226933,
    y: 32.0712695,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C94E2A",
    x: 11.6708229,
    y: 32.0712695,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#B6FF00",
    cx: 33.0822943,
    cy: 33.0066815,
    rx: 1.12219451,
    ry: 1.11358575
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 17.9551122,
    y: 30.2895323,
    width: 12.2992519,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#FFFFFF",
    x: 18.0448878,
    y: 32.0712695,
    width: 12.2992519,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#FFFFFF",
    x: 18.0448878,
    y: 33.8530067,
    width: 12.2992519,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#FFFFFF",
    x: 18.0448878,
    y: 35.6347439,
    width: 12.2992519,
    height: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerside);
export default __webpack_public_path__ + "static/media/serverside.b05020ef221404bd72ab8e1920bde350.svg";
export { ForwardRef as ReactComponent };